// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/SiteIcons/calenderLeft.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../public/SiteIcons/calenderRight.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.becomeHostCalendarContainer {
    display: block;
}

.becomeHostCalendarContainer .becomeHostMonthsGroup {
    width: 100%;
    max-width: 100%;
}

.becomeHostCalendarContainer .becomeHostSingleMonth {
    width: 100%;
}

.becomeHostCalendarContainer .becomeHostMonthTable {
    width: 100%;
}

.becomeHostCalendarContainer .weekdaySection {
    position: relative;
    font-size: 16px;
    font-weight: 700;
    height: 64px;
    color: var(--common-text-color);
    border: 1px solid var(--white-text);
    text-transform: unset;
    text-align: center;
    padding: 0;
    opacity: 1;
}

.becomeHostCalendarContainer .becomeHostSingleDay {
    position: relative;
    width: calc(100% / 7);
    height: 114px;
    border: 2px solid var(--white-text);
    background: var(--becomeHost-calendar-available-bg);
    color: var(--common-text-color);
    z-index: 1;
    border-radius: 6px;
    cursor: pointer;
}

.becomeHostCalendarContainer .priceAlignment {
    display: inline-block;
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    overflow: hidden;
    z-index: -1;
}

.becomeHostCalendarContainer .priceAlignment>span {
    display: block;
    text-align: start;
    font-size: 14px;
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
    max-width: 100%;
    color: var(--calendarDay-primary-foreground);
}

.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar {
    height: 5px;
}

.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #f1f1f1;
    border-radius: 10px;
}

.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.becomeHostCalendarContainer .becomeHostInnerDayBtn {
    position: relative;
    padding: 10px;
    font-size: 18px;
    font-weight: 400;
    text-align: start;
    vertical-align: top;
    outline: 0;
    width: 100%;
    height: 100%;
    border: unset;
    background: transparent;
    color: unset;
    border-radius: inherit;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: inherit;
    z-index: -2;
}

.becomeHostCalendarContainer .becomeHostSingleDay:hover {
    background: var(--becomeHost-calendar-available-hover);
    color: var(--common-text-color);
}

.becomeHostCalendarContainer .rdp-hidden.rdp-outside {
    background: transparent;
    color: transparent;
    cursor: default;
}

.becomeHostCalendarContainer .disabledDates:not(.rdp-outside):not(.rdp-hidden):not(.fullyBooked) {
    background: var(--becomeHost-calendar-disabled-bg);
    color: var(--secondary-foreground);
    opacity: 1;
    cursor: not-allowed;
}

.becomeHostCalendarContainer .rdp-today {
    color: var(--becomeHost-calendar-today-foreground);
    font-weight: 500;
}

.becomeHostCalendarContainer .becomeHostMonthCaption {
    margin-bottom: 18px;
}

.becomeHostCalendarContainer .becomeHostMonthCaption .becomeHostMonthCaptionLabel {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    max-width: 200px;
    height: 48px;
    position: relative;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    border: 1px solid var(--primary-border);
    border-radius: 6px;
}

.becomeHostCalendarContainer .becomeHostMonthNav {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    justify-content: space-between;
    text-align: center;
    width: 100%;
    max-width: 200px;
    height: 48px;
    z-index: 2;
}

.becomeHostCalendarContainer .becomeHostMonthNav .chevronHidden {
    display: none;
}

.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before,
.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {
    content: "";
    width: 8px;
    height: 24px;
}

.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.becomeHostMonthNavPrevBtn,
.becomeHostMonthNavNextBtn {
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    appearance: none;
    width: 36px;
    height: 36px;
}

.becomeHostCalendarBox {
    position: relative;
}

.becomeHostCalendarTodayBtn {
    position: absolute;
    top: 0;
    right: 0;
}

.becomeHostCalendarTodayBtn,
.becomeHostCalendarTodayBtn:hover,
.becomeHostCalendarTodayBtn:focus,
.becomeHostCalendarTodayBtn:active:focus,
.becomeHostCalendarTodayBtn:active:hover {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--btn-primary-bg);
    border-radius: 5px;
    background-color: var(--btn-primary-bg);
    color: var(--white-text);
    font-size: 16px;
    font-weight: 400;
    padding: 12px 22px;
    z-index: 2;
}

.becomeHostMonthNav .becomeHostMonthNavPrevBtn[aria-disabled="true"],
.becomeHostMonthNav .becomeHostMonthNavNextBtn[aria-disabled="true"] {
    opacity: .5;
    cursor: not-allowed;
}

.becomeHostCalendarContainer .fullyAvailable,
.becomeHostCalendarContainer .fullyAvailable:hover {
    background: var(--becomeHost-calendar-specialDay-bg);
    color: var(--common-text-color);
}

.becomeHostCalendarContainer .fullyBlocked,
.becomeHostCalendarContainer .fullyBlocked:hover {
    background: var(--becomeHost-calendar-blockDay-bg);
    color: var(--common-text-color);
}

.becomeHostCalendarContainer .customDayCalendarSelecting,
.becomeHostCalendarContainer .customDayCalendarSelecting:hover {
    background: var(--becomeHost-Selected-bg) !important;
    color: var(--common-text-color) !important;
}

.becomeHostCalendarContainer .fullyBooked,
.becomeHostCalendarContainer .fullyBooked:hover {
    background: var(--becomeHost-calendar-bookedDay-bg);
    color: var(--common-text-color);
    cursor: not-allowed;
}

/* rtl start  */

.rtl .becomeHostCalendarContainer .becomeHostMonthNav {
    left: unset;
    right: 0;
}

.rtl .becomeHostCalendarTodayBtn {
    right: unset;
    left: 0;
}

.rtl .becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before,
.rtl .becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {
    transform: rotate(180deg);
}

/* rtl end  */

/* media start  */
@media (max-width: 1199px) {
    .becomeHostCalendarSpacing {
        margin-bottom: 50px;
    }
}

@media (max-width: 767px) {
    .becomeHostCalendarContainer .weekdaySection {
        font-size: 11px;
        height: 44px;
    }

    .becomeHostCalendarContainer .becomeHostInnerDayBtn {
        font-size: 12px;
    }

    .becomeHostCalendarContainer .priceAlignment>span {
        font-size: 10px;
    }

    .becomeHostCalendarContainer .becomeHostMonthCaption {
        margin-bottom: 62px;
    }

    .becomeHostCalendarContainer .becomeHostMonthCaption .becomeHostMonthCaptionLabel {
        font-size: 14px;
        max-width: 100%;
    }

    .becomeHostCalendarContainer .becomeHostMonthNav {
        max-width: 100%;
    }

    .becomeHostCalendarTodayBtn {
        right: 0;
        left: 0;
        width: 100%;
        top: 58px;
    }
}

@media (max-width: 767px) and (min-width: 576px) {
    .becomeHostCalendarContainer .becomeHostSingleDay {
        height: 70px;
    }

    .becomeHostCalendarContainer .becomeHostInnerDayBtn {
        padding: 6px;
    }

    .becomeHostCalendarContainer .priceAlignment {
        bottom: 6px;
        left: 6px;
        right: 6px;
    }
}

@media (max-width: 575px) and (min-width: 361px) {
    .becomeHostCalendarContainer .becomeHostSingleDay {
        height: 60px;
    }
}

@media (max-width: 575px) {
    .becomeHostCalendarContainer .becomeHostInnerDayBtn {
        padding: 4px;
    }

    .becomeHostCalendarContainer .priceAlignment {
        bottom: 4px;
        left: 4px;
        right: 4px;
    }
}


@media (max-width: 360px) {
    .becomeHostCalendarContainer .becomeHostSingleDay {
        height: 50px;
    }
}

/* media end  */`, "",{"version":3,"sources":["webpack://./src/styles/becomeHostCalendar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mCAAmC;IACnC,mDAAmD;IACnD,+BAA+B;IAC/B,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sDAAsD;IACtD,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kCAAkC;IAClC,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,yDAAgE;IAChE,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yDAAiE;IACjE,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;;;;;IAKI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,kBAAkB;IAClB,uCAAuC;IACvC,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,oDAAoD;IACpD,+BAA+B;AACnC;;AAEA;;IAEI,kDAAkD;IAClD,+BAA+B;AACnC;;AAEA;;IAEI,oDAAoD;IACpD,0CAA0C;AAC9C;;AAEA;;IAEI,mDAAmD;IACnD,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,eAAe;;AAEf;IACI,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,aAAa;;AAEb,iBAAiB;AACjB;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,OAAO;QACP,WAAW;QACX,SAAS;IACb;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,UAAU;IACd;AACJ;;;AAGA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,eAAe","sourcesContent":[".becomeHostCalendarContainer {\n    display: block;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthsGroup {\n    width: 100%;\n    max-width: 100%;\n}\n\n.becomeHostCalendarContainer .becomeHostSingleMonth {\n    width: 100%;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthTable {\n    width: 100%;\n}\n\n.becomeHostCalendarContainer .weekdaySection {\n    position: relative;\n    font-size: 16px;\n    font-weight: 700;\n    height: 64px;\n    color: var(--common-text-color);\n    border: 1px solid var(--white-text);\n    text-transform: unset;\n    text-align: center;\n    padding: 0;\n    opacity: 1;\n}\n\n.becomeHostCalendarContainer .becomeHostSingleDay {\n    position: relative;\n    width: calc(100% / 7);\n    height: 114px;\n    border: 2px solid var(--white-text);\n    background: var(--becomeHost-calendar-available-bg);\n    color: var(--common-text-color);\n    z-index: 1;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.becomeHostCalendarContainer .priceAlignment {\n    display: inline-block;\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.becomeHostCalendarContainer .priceAlignment>span {\n    display: block;\n    text-align: start;\n    font-size: 14px;\n    overflow-x: auto;\n    white-space: nowrap;\n    width: 100%;\n    max-width: 100%;\n    color: var(--calendarDay-primary-foreground);\n}\n\n.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar {\n    height: 5px;\n}\n\n.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px #f1f1f1;\n    border-radius: 10px;\n}\n\n.becomeHostCalendarContainer .priceAlignment>span::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n}\n\n.becomeHostCalendarContainer .becomeHostInnerDayBtn {\n    position: relative;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: 400;\n    text-align: start;\n    vertical-align: top;\n    outline: 0;\n    width: 100%;\n    height: 100%;\n    border: unset;\n    background: transparent;\n    color: unset;\n    border-radius: inherit;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    cursor: inherit;\n    z-index: -2;\n}\n\n.becomeHostCalendarContainer .becomeHostSingleDay:hover {\n    background: var(--becomeHost-calendar-available-hover);\n    color: var(--common-text-color);\n}\n\n.becomeHostCalendarContainer .rdp-hidden.rdp-outside {\n    background: transparent;\n    color: transparent;\n    cursor: default;\n}\n\n.becomeHostCalendarContainer .disabledDates:not(.rdp-outside):not(.rdp-hidden):not(.fullyBooked) {\n    background: var(--becomeHost-calendar-disabled-bg);\n    color: var(--secondary-foreground);\n    opacity: 1;\n    cursor: not-allowed;\n}\n\n.becomeHostCalendarContainer .rdp-today {\n    color: var(--becomeHost-calendar-today-foreground);\n    font-weight: 500;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthCaption {\n    margin-bottom: 18px;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthCaption .becomeHostMonthCaptionLabel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n    max-width: 200px;\n    height: 48px;\n    position: relative;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: normal;\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthNav {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    justify-content: space-between;\n    text-align: center;\n    width: 100%;\n    max-width: 200px;\n    height: 48px;\n    z-index: 2;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthNav .chevronHidden {\n    display: none;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before,\n.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {\n    content: \"\";\n    width: 8px;\n    height: 24px;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before {\n    background-image: url(\"../../public/SiteIcons/calenderLeft.svg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {\n    background-image: url(\"../../public/SiteIcons/calenderRight.svg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.becomeHostMonthNavPrevBtn,\n.becomeHostMonthNavNextBtn {\n    border: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    appearance: none;\n    width: 36px;\n    height: 36px;\n}\n\n.becomeHostCalendarBox {\n    position: relative;\n}\n\n.becomeHostCalendarTodayBtn {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.becomeHostCalendarTodayBtn,\n.becomeHostCalendarTodayBtn:hover,\n.becomeHostCalendarTodayBtn:focus,\n.becomeHostCalendarTodayBtn:active:focus,\n.becomeHostCalendarTodayBtn:active:hover {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--btn-primary-bg);\n    border-radius: 5px;\n    background-color: var(--btn-primary-bg);\n    color: var(--white-text);\n    font-size: 16px;\n    font-weight: 400;\n    padding: 12px 22px;\n    z-index: 2;\n}\n\n.becomeHostMonthNav .becomeHostMonthNavPrevBtn[aria-disabled=\"true\"],\n.becomeHostMonthNav .becomeHostMonthNavNextBtn[aria-disabled=\"true\"] {\n    opacity: .5;\n    cursor: not-allowed;\n}\n\n.becomeHostCalendarContainer .fullyAvailable,\n.becomeHostCalendarContainer .fullyAvailable:hover {\n    background: var(--becomeHost-calendar-specialDay-bg);\n    color: var(--common-text-color);\n}\n\n.becomeHostCalendarContainer .fullyBlocked,\n.becomeHostCalendarContainer .fullyBlocked:hover {\n    background: var(--becomeHost-calendar-blockDay-bg);\n    color: var(--common-text-color);\n}\n\n.becomeHostCalendarContainer .customDayCalendarSelecting,\n.becomeHostCalendarContainer .customDayCalendarSelecting:hover {\n    background: var(--becomeHost-Selected-bg) !important;\n    color: var(--common-text-color) !important;\n}\n\n.becomeHostCalendarContainer .fullyBooked,\n.becomeHostCalendarContainer .fullyBooked:hover {\n    background: var(--becomeHost-calendar-bookedDay-bg);\n    color: var(--common-text-color);\n    cursor: not-allowed;\n}\n\n/* rtl start  */\n\n.rtl .becomeHostCalendarContainer .becomeHostMonthNav {\n    left: unset;\n    right: 0;\n}\n\n.rtl .becomeHostCalendarTodayBtn {\n    right: unset;\n    left: 0;\n}\n\n.rtl .becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavPrevBtn::before,\n.rtl .becomeHostCalendarContainer .becomeHostMonthNav .becomeHostMonthNavNextBtn::before {\n    transform: rotate(180deg);\n}\n\n/* rtl end  */\n\n/* media start  */\n@media (max-width: 1199px) {\n    .becomeHostCalendarSpacing {\n        margin-bottom: 50px;\n    }\n}\n\n@media (max-width: 767px) {\n    .becomeHostCalendarContainer .weekdaySection {\n        font-size: 11px;\n        height: 44px;\n    }\n\n    .becomeHostCalendarContainer .becomeHostInnerDayBtn {\n        font-size: 12px;\n    }\n\n    .becomeHostCalendarContainer .priceAlignment>span {\n        font-size: 10px;\n    }\n\n    .becomeHostCalendarContainer .becomeHostMonthCaption {\n        margin-bottom: 62px;\n    }\n\n    .becomeHostCalendarContainer .becomeHostMonthCaption .becomeHostMonthCaptionLabel {\n        font-size: 14px;\n        max-width: 100%;\n    }\n\n    .becomeHostCalendarContainer .becomeHostMonthNav {\n        max-width: 100%;\n    }\n\n    .becomeHostCalendarTodayBtn {\n        right: 0;\n        left: 0;\n        width: 100%;\n        top: 58px;\n    }\n}\n\n@media (max-width: 767px) and (min-width: 576px) {\n    .becomeHostCalendarContainer .becomeHostSingleDay {\n        height: 70px;\n    }\n\n    .becomeHostCalendarContainer .becomeHostInnerDayBtn {\n        padding: 6px;\n    }\n\n    .becomeHostCalendarContainer .priceAlignment {\n        bottom: 6px;\n        left: 6px;\n        right: 6px;\n    }\n}\n\n@media (max-width: 575px) and (min-width: 361px) {\n    .becomeHostCalendarContainer .becomeHostSingleDay {\n        height: 60px;\n    }\n}\n\n@media (max-width: 575px) {\n    .becomeHostCalendarContainer .becomeHostInnerDayBtn {\n        padding: 4px;\n    }\n\n    .becomeHostCalendarContainer .priceAlignment {\n        bottom: 4px;\n        left: 4px;\n        right: 4px;\n    }\n}\n\n\n@media (max-width: 360px) {\n    .becomeHostCalendarContainer .becomeHostSingleDay {\n        height: 50px;\n    }\n}\n\n/* media end  */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
